import {
  TIPO_ASIENTO_LABELS,
  TipoAsientoLabelsProps,
} from "features/Contabilidad/pages/LibroMayor/constants/TipoAsientoLabels"
import { TFunction } from "i18next"

export const CUADRO_CUENTAS_CONTABLES_DEFAULT_FILTER = (t: TFunction) => ({
  date: [new Date(`${new Date().getFullYear()}-01-01`), new Date()],

  keyword: undefined,
  selectedType: TIPO_ASIENTO_LABELS(t)[0],
  filtroSwitch: {
    switch: false,
    tieneMovimiento: true,
  },
  pagination: {
    itemsPerPage: 100,
    skipCount: 0,
  },
})

export type CuadroCuentasContablesFilterProps = {
  date: Date[] | undefined
  keyword: string
  selectedType: TipoAsientoLabelsProps
  filtroSwitch: {
    switch: boolean
    tieneMovimiento: boolean
  }
  pagination: {
    itemsPerPage: number
    skipCount: number
  }
}
